/**
 * "Update ready" bar - shown on every app once a newer build is deployed and the
 * page has not reloaded on its own yet (see pwa/autoUpdate.js). While a payment or
 * cart holds the update, Reload waits for it.
 */
import React from 'react';
import { applyUpdate, useAutoUpdate } from './autoUpdate';

export default function UpdateReadyBar() {
  const { ready, held } = useAutoUpdate();
  if (!ready) return null;
  return (
    <div
      role="status"
      data-testid="pwa-update-ready"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[9999] flex items-center gap-3 rounded-lg bg-zinc-900 text-white px-4 py-3 shadow-lg border border-white/10"
    >
      <span className="text-sm">
        {held ? 'A new version is ready. It installs when this sale is finished.' : 'A new version is ready.'}
      </span>
      <button
        type="button"
        data-testid="pwa-update-reload"
        disabled={held}
        onClick={() => applyUpdate()}
        className="rounded-md bg-orange-600 px-3 py-1.5 text-sm font-medium disabled:opacity-50"
      >
        Reload
      </button>
    </div>
  );
}
